import { render } from "./BrandLogo.vue?vue&type=template&id=54bb1d27&scoped=true&ts=true"
import script from "./BrandLogo.vue?vue&type=script&lang=ts"
export * from "./BrandLogo.vue?vue&type=script&lang=ts"

import "./BrandLogo.vue?vue&type=style&index=0&id=54bb1d27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bb1d27"]])

export default __exports__